import { AnyAction, PayloadAction } from '@reduxjs/toolkit'

export function isFulfilled<T>(prefix = '') {
  return (action: AnyAction): action is PayloadAction<T> =>
    action.type?.endsWith('fulfilled') && action.type?.startsWith(prefix)
}
